import { Pipe, PipeTransform } from '@angular/core';
import { ITraveller } from "libraries/service/resources/booking/interfaces/IGetBookings";

@Pipe({
    name: 'hasTravellersInfos'
})

export class HasTravellersInfosPipe implements PipeTransform {
    public transform(travellers: ITraveller[]): boolean {
        return Boolean(travellers.find((traveller:ITraveller) => Boolean(traveller.firstName || traveller.lastName)));
    }
}